export const awardHost = "https://germanwahnsinn.de/";
